import { Action } from 'redux-actions';
import { ImmutableObject, isImmutable } from 'seamless-immutable';

import * as actions from './actions';

export default <State extends ImmutableObject<unknown>>(reducerName: string): {
  [actionType: string]: (state: State, action: Action<any>) => ImmutableObject<unknown>
} => ({
  [actions.getList(reducerName).toString()]: (state) => {
    if (!isImmutable(state)) {
      return state;
    }
    return state.set('loading', true);
  },
  [actions.setList(reducerName).toString()]: (state, { payload }: Action<actions.ISetList<unknown>>) => {
    if (!isImmutable(state)) {
      return state;
    }

    if (!payload) {
      return state.merge({
        loaded: true,
        loading: false,
        items: null,
        total: 0,
        loadingItems: {},
      });
    }

    // eslint-disable-next-line react/destructuring-assignment
    return state.merge({
      loaded: true,
      loading: false,
      items: payload.items,
      total: payload.total,
      hasData: payload.hasData, // если у кого то нету - пофиг
      loadingItems: {}, // если у кого то нету - пофиг
    });
  },
  [actions.setChunkList(reducerName).toString()]: (state, { payload }) => {
    if (!isImmutable(state)) {
      return state;
    }

    return state.merge({
      loaded: true,
      loading: false,
      // @ts-ignore may contain items
      items: state.items?.concat(payload),
    });
  },
  [actions.setLoadingItemPrimitive(reducerName).toString()]: (state, { payload }) => {
    if (!isImmutable(state) || !payload) {
      return state;
    }

    return state.setIn(['loadingItems', payload], true);
  },
  [actions.setLoadingItem(reducerName).toString()]: (state, { payload }) => {
    if (!isImmutable(state) || !payload) {
      return state;
    }
    return state.setIn(['loadingItems', payload.id], true);
  },
  [actions.setLoadingItemDone(reducerName).toString()]: (state, { payload }) => {
    if (!isImmutable(state) || !payload) {
      return state;
    }
    return state.setIn(['loadingItems', `${payload}`], false);
  },
});
